import { CpDataApi } from '../../cp-xhr';
import { getConsultDecisionClientEndpoint, getMakeDecisionEndpoint } from '@cp-es/common';
import { MakeDecisionRequestBody } from '@cp-es/common/src/apis/services';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';

export const makeClientDecision = async (
    encryptedContractId: string,
    action: string,
    data?: MakeDecisionRequestBody,
): Promise<void> => {
    return CpDataApi.post(getMakeDecisionEndpoint(encryptedContractId, action), data);
};

export function useClientDecision(contractId: string) {
    const [data, setData] = useState('');
    const [error, setError] = useState<string>('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async function() {
            try {
                setLoading(true);
                const response = await CpDataApi.get(getConsultDecisionClientEndpoint(contractId));
                setData(response.data);
            } catch (err) {
                setError((err as AxiosError<{ message: string }>)?.response?.data?.message || '');
            } finally {
                setLoading(false);
            }
        })();
    }, [contractId]);

    return { data, error, loading };
}
